<div class="row" fxFlex="100%" fxLayout="row wrap" >
  <div fxFlex="50%" style="margin-top: 45px;" >
    <div fxLayout="row" fxLayoutGap="10px" >
      <div fxFlex="33%" >
              <mat-form-field appearance="standard" class="compact-form-field"  style="width: 100%;">

              <mat-select [(ngModel)]="criteria.simple.documentType" (selectionChange)="setDocumentType($event.value)">
                <mat-option value="purbol">Pickup Request</mat-option>
                <mat-option value="invoice">Invoice</mat-option>
                <mat-option value="status">Shipment Status</mat-option>
                <mat-option value="delimani">Delivery Manifest</mat-option>
                <mat-option value="any">Any</mat-option>
              </mat-select>
              <mat-label>Document Type</mat-label>
            </mat-form-field>
      </div>

          <div fxFlex="33%">
            <mat-form-field appearance="fill" class="compact-form-field" style="width: 100%;">
              <mat-label>ISA Sender ID</mat-label>
              <input matInput [(ngModel)]="criteria.simple.isaSenderId" style="font-size: 12px"/>
            </mat-form-field>
          </div>

          <div fxFlex="33%">
            <mat-form-field appearance="fill" class="compact-form-field" style="width: 100%;">
              <mat-label>ISA Receiver ID</mat-label>
              <input matInput [(ngModel)]="criteria.simple.isaReceiverId"/>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
          <div fxFlex="33%">
            <mat-form-field appearance="standard" class="compact-form-field"  style="width: 100%;">
              <mat-select [(ngModel)]="criteria.simple.usageInd">
                <mat-option value="any">Test and Production</mat-option>
                <mat-option value="p">Production</mat-option>
                <mat-option value="t">Test</mat-option>
              </mat-select>
              <mat-label>Document Region</mat-label>
            </mat-form-field>
          </div>

          <div fxFlex="33%">
            <mat-form-field appearance="fill" class="compact-form-field" style="width: 100%;">
              <mat-label>GS Sender ID</mat-label>
              <input matInput [(ngModel)]="criteria.simple.gsSenderId"/>
            </mat-form-field>
          </div>

          <div fxFlex="33%">
            <mat-form-field appearance="fill" class="compact-form-field" style="width: 100%;">
              <mat-label>GS Receiver ID</mat-label>
              <input matInput [(ngModel)]="criteria.simple.gsReceiverId"/>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" style="margin-top: 20px;">
          <div fxFlex="50%">
            <mat-form-field appearance="standard" class="compact-form-field" *ngIf="criteria.simple.timeRange !== 'custom'" style="width: 100%;">
              <mat-label>Time Range</mat-label>
              <mat-select [(ngModel)]="criteria.simple.timeRange" aria-label="time range filter">
                <mat-option value="disabled">Limit the results to a time range</mat-option>
                <mat-option value="86400">Last 24 hours</mat-option>
                <mat-option value="172800">Last 48 hours</mat-option>
                <mat-option value="604800">Last 7 days</mat-option>
                <mat-option value="2592000">Last 30 days</mat-option>
                <mat-option value="7776000">Last 90 days</mat-option>
                <mat-option value="15552000">Last 180 days</mat-option>
                <mat-option value="31536000">Last 365 days</mat-option>
                <mat-option value="78840000">Forever</mat-option>
                <mat-option value="custom">Custom date range...</mat-option>
              </mat-select>
            </mat-form-field>

            <div *ngIf="criteria.simple.timeRange === 'custom'">
              <mat-form-field appearance="fill" class="compact-form-field">
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="startPicker" [(ngModel)]="criteria.simple.startTimeRange" [max]="criteria.simple.endTimeRange" required/>
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill" class="compact-form-field">
                <mat-label>End Date</mat-label>
                <input matInput [matDatepicker]="endPicker" [(ngModel)]="criteria.simple.endTimeRange" [min]="criteria.simple.startTimeRange" [max]="criteria.simple.maxEndTime" required/>
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </mat-form-field>
              <button mat-icon-button (click)="criteria.simple.timeRange = '86400'" title="Switch back to time range options">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>

          <div fxFlex="50%">
            <mat-form-field appearance="standard" class="compact-form-field" style="width: 100%;">
              <mat-label>Order By</mat-label>
              <mat-select [(ngModel)]="criteria.simple.orderBy" aria-label="sort">
                <mat-option value="disabled">Sort order</mat-option>
                <mat-option value="isa.timestamp:desc">ISA timestamp (Newest to Oldest)</mat-option>
                <mat-option value="isa.timestamp:asc">ISA timestamp (Oldest to Newest)</mat-option>
                <mat-option value="_score">Match Score</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Reference Numbers heading/description -->
        <div>
          <h6>Reference Numbers
            <button mat-icon-button aria-label="Help" (click)="openHelp('reference')">
              <mat-icon>help_outline</mat-icon>
            </button>
          </h6>
          <p style="font-size: 80%; margin-top: 0; margin-bottom: 4px;">Limit results based on reference numbers, such as <strong>PRO</strong> for XPO&#039;s PRO, <strong>SN#</strong> for EDI sender shipment ID and any other reference number.</p>
        </div>

      </div>



  <div fxLayout="column" fxFlex="50%" style="margin-top: 45px;">

    <!-- Three party blocks side‑by‑side → a nested row -->
    <div fxLayout="row"
         fxLayoutAlign="start stretch">

      <div class="party-block" fxFlex="33%">
        <div fxLayout="row" fxLayoutAlign="start center" style="margin-bottom: 8px;">
         <h3 class="mat-h3" style="margin: 0;">Shipper</h3>
         <button mat-icon-button aria-label="Shipper help" (click)="openHelp('parties')" style="margin-left: 4px;">
           <mat-icon>help_outline</mat-icon>
         </button>
        </div>
        <party-criteria [partyType]="'Shipper'"
                       [party]="criteria.simple.shipper"
                       (onOpenHelp)="openHelp($event)">
        </party-criteria>
      </div>

      <div class="party-block" fxFlex="33%">
        <div fxLayout="row" fxLayoutAlign="start center" style="margin-bottom: 8px;">
         <h3 class="mat-h3" style="margin: 0;">Consignee</h3>
         <button mat-icon-button aria-label="Consignee help" (click)="openHelp('parties')" style="margin-left: 4px;">
           <mat-icon>help_outline</mat-icon>
         </button>
        </div>
        <party-criteria [partyType]="'Consignee'"
                       [party]="criteria.simple.consignee"
                       (onOpenHelp)="openHelp($event)">
        </party-criteria>
      </div>

      <div class="party-block" fxFlex="33%">
        <div fxLayout="row" fxLayoutAlign="start center" style="margin-bottom: 8px;">
         <h3 class="mat-h3" style="margin: 0;">BillTo</h3>
         <button mat-icon-button aria-label="BillTo help" (click)="openHelp('parties')" style="margin-left: 4px;">
           <mat-icon>help_outline</mat-icon>
         </button>
        </div>
        <party-criteria [partyType]="'BillTo'"
                       [party]="criteria.simple.billTo"
                       (onOpenHelp)="openHelp($event)">
        </party-criteria>
      </div>

    </div>

  </div>

  <!-- Reference Numbers fields (full width row) -->
  <div fxFlex="100%">
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <!-- Input fields for adding new reference -->
      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" style="flex-wrap: nowrap;">
        <mat-form-field appearance="fill" class="compact-form-field" fxFlex="150px">
          <mat-label>Type, e.g. SN#</mat-label>
          <input matInput [(ngModel)]="refType" title="The reference number type, to do multiple use a comma, e.g. SN#, SN"/>
        </mat-form-field>
        <mat-form-field appearance="fill" class="compact-form-field" fxFlex="200px">
          <mat-label>Reference Number</mat-label>
          <input matInput [(ngModel)]="refValue" title="The reference number value to search for"/>
        </mat-form-field>
        <button mat-icon-button color="primary" aria-label="Add reference number" (click)="addReferenceNumber({ type: refType, value: refValue })" title="Add this reference number">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>

      <!-- Added reference numbers as non-editable fields (wrapped in groups) -->
      <ng-container *ngFor="let referenceNumber of criteria.simple.referenceNumbers">
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" style="flex-wrap: nowrap;">
          <mat-form-field appearance="fill" class="compact-form-field" fxFlex="150px">
            <mat-label>Type</mat-label>
            <input matInput [value]="referenceNumber.type" disabled/>
          </mat-form-field>
          <mat-form-field appearance="fill" class="compact-form-field" fxFlex="200px">
            <mat-label>Reference Number</mat-label>
            <input matInput [value]="referenceNumber.value" disabled/>
          </mat-form-field>
          <button mat-icon-button color="warn" (click)="removeReferenceNumber(referenceNumber)" title="Remove this reference number">
            <mat-icon>remove_circle</mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
